import PropTypes from 'prop-types';
import React from 'react';
import ResourceFooterLeftSide from './ResourceFooterLeftSide';
import ResourceFooterRightSide from './ResourceFooterRightSide';

var DashboardResourceFooter = function DashboardResourceFooter(_ref) {
  var licence = _ref.licence,
      licencingSchool = _ref.licencingSchool,
      owns = _ref.owns,
      resourceId = _ref.resourceId,
      resourceUrl = _ref.resourceUrl,
      noDeleteButton = _ref.noDeleteButton,
      noDownloadButton = _ref.noDownloadButton,
      noBuyButton = _ref.noBuyButton,
      noRatingButtons = _ref.noRatingButtons,
      onDeleteButtonClick = _ref.onDeleteButtonClick,
      onBasketCheckboxChange = _ref.onBasketCheckboxChange,
      basketCheckboxChecked = _ref.basketCheckboxChecked,
      noAddToBasketCheckbox = _ref.noAddToBasketCheckbox,
      rating = _ref.rating,
      ratingValue = _ref.ratingValue,
      onRatingStarClick = _ref.onRatingStarClick,
      onRatingLabelClick = _ref.onRatingLabelClick,
      ratingLabelText = _ref.ratingLabelText,
      ratingStarColor = _ref.ratingStarColor,
      onBuyButtonClick = _ref.onBuyButtonClick,
      onDownloadButtonClick = _ref.onDownloadButtonClick,
      buyButtonHref = _ref.buyButtonHref,
      downloadButtonHref = _ref.downloadButtonHref,
      isSchoolLicenceUpgradeAvailable = _ref.isSchoolLicenceUpgradeAvailable,
      schoolLicenceUpgradeButtonUrl = _ref.schoolLicenceUpgradeButtonUrl,
      licences = _ref.licences;
  return /*#__PURE__*/React.createElement("div", {
    className: "dashboard-card__footer"
  }, /*#__PURE__*/React.createElement(ResourceFooterLeftSide, {
    licence: licence,
    owns: owns,
    licencingSchool: licencingSchool,
    noDeleteButton: noDeleteButton,
    onDeleteButtonClick: onDeleteButtonClick,
    rating: rating,
    ratingValue: ratingValue,
    onRatingStarClick: onRatingStarClick,
    onRatingLabelClick: onRatingLabelClick,
    ratingLabelText: ratingLabelText,
    ratingStarColor: ratingStarColor
  }), owns && !noRatingButtons && /*#__PURE__*/React.createElement("span", {
    className: "dashboard-card__footer__review-buttons"
  }, /*#__PURE__*/React.createElement("img", {
    src: "http://d2v8ggac1o0f6z.cloudfront.net/gsc/E5WPOE/e0/06/22/e006220d1aef4bce8a5df84e4c2cdf8a/images/buyersellerdashboard/good_u3771.png?token=e8200c977485aafb85bfc4f8152a7ff6",
    alt: ""
  }), /*#__PURE__*/React.createElement("img", {
    src: "http://d2v8ggac1o0f6z.cloudfront.net/gsc/E5WPOE/e0/06/22/e006220d1aef4bce8a5df84e4c2cdf8a/images/buyersellerdashboard/bad_u3773.png?token=b892a891eb017fa78212251adab66012",
    alt: ""
  })), /*#__PURE__*/React.createElement(ResourceFooterRightSide, {
    licence: licence,
    owns: owns,
    resourceId: resourceId,
    resourceUrl: resourceUrl,
    noDownloadButton: noDownloadButton,
    noBuyButton: noBuyButton,
    onBasketCheckboxChange: onBasketCheckboxChange,
    basketCheckboxChecked: basketCheckboxChecked,
    noAddToBasketCheckbox: noAddToBasketCheckbox,
    onBuyButtonClick: onBuyButtonClick,
    onDownloadButtonClick: onDownloadButtonClick,
    buyButtonHref: buyButtonHref,
    downloadButtonHref: downloadButtonHref,
    isSchoolLicenceUpgradeAvailable: isSchoolLicenceUpgradeAvailable,
    schoolLicenceUpgradeButtonUrl: schoolLicenceUpgradeButtonUrl,
    licences: licences
  }));
};

DashboardResourceFooter.displayName = "DashboardResourceFooter";
DashboardResourceFooter.propTypes = {
  licence: PropTypes.string,
  licencingSchool: PropTypes.string,
  owns: PropTypes.bool.isRequired,
  resourceId: PropTypes.string.isRequired,
  resourceUrl: PropTypes.string.isRequired,
  noDeleteButton: PropTypes.bool,
  noDownloadButton: PropTypes.bool,
  noBuyButton: PropTypes.bool,
  noAddToBasketCheckbox: PropTypes.bool,
  noRatingButtons: PropTypes.bool,
  onDeleteButtonClick: PropTypes.func,
  onBasketCheckboxChange: PropTypes.func,
  basketCheckboxChecked: PropTypes.bool,
  rating: PropTypes.bool,
  ratingValue: PropTypes.number,
  onRatingStarClick: PropTypes.func,
  onRatingLabelClick: PropTypes.func,
  ratingLabelText: PropTypes.string,
  ratingStarColor: PropTypes.string,
  onBuyButtonClick: PropTypes.func,
  onDownloadButtonClick: PropTypes.func,
  buyButtonHref: PropTypes.string,
  downloadButtonHref: PropTypes.string,
  isSchoolLicenceUpgradeAvailable: PropTypes.bool,
  schoolLicenceUpgradeButtonUrl: PropTypes.string,
  licences: PropTypes.arrayOf(PropTypes.string)
};
export default DashboardResourceFooter;